import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCta() {
  return <section className="py-24 px-4 bg-brand-navy text-center relative overflow-hidden" data-id="element-33">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,83,0.1)_0,transparent_50%)] pointer-events-none" data-id="element-34"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-36">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-cream mb-8 leading-tight" data-id="element-37">
            ¿Lista para recuperar la atención de tu hijo y la paz en tu hogar?
          </h2>

          <p className="text-xl text-brand-cream/70 mb-12 font-serif italic" data-id="element-38">
            El tiempo pasa rápido. No dejes que las pantallas se roben su
            infancia.
          </p>

          <div className="max-w-2xl mx-auto" data-id="element-39">
            <CTAButton className="py-5 text-lg md:text-xl" href="https://pay.hotmart.com/I105257953Q?off=p3on1myk&bid=1775510463890" data-id="element-40" />
          </div>
        </motion.div>
      </div>
    </section>;
}